"use client";

import React, { useEffect, useState, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
import { Icon } from "@iconify/react";

import styles from "./courses.module.scss";
import Components from "@/components";
import useApi from "@/hooks/useApi";
import sk from "@/skeletons";
import api from "@/api";
import "./swiper.css";

const page = 1;
const limit = 1;
function LatestCourse({ gap, vidPerView }) {
  const [latest, setLatest] = useState([]);
  const { data: latestCourse, request: loadFilterCourse } = useApi(
    api.getfilteredcourse
  );
  const {
    data: unWrapCourse,
    request: fetchUnwrapCourse,
    loading,
  } = useApi(api.getUnwrapCourse);

  useEffect(() => {
    fetchUnwrapCourse(page, limit);
  }, [page, limit]);

  useEffect(() => {
    if (unWrapCourse?.data) {
      setLatest((prevLatest) => [...unWrapCourse.data, ...prevLatest]);
    }
  }, [unWrapCourse]);

  useEffect(() => {
    loadFilterCourse("Latest");
  }, []);

  useEffect(() => {
    if (latestCourse.data) {
      setLatest((prevLatest) => [...prevLatest, ...latestCourse.data]);
    }
  }, [latestCourse]);

  const unwrap = useMemo(() => {
    if (latest?.length > 0) {
      const currentData = unWrapCourse?.video;
      return {
        type: "course",
        id: latest?.[0]?._id,
        courseTitle: latest?.[0]?.title,
        courseSeoTitle: unWrapCourse?.data?.[0]?.seoTitle,
        videoTitle: [
          currentData?.[0]?.title,
          currentData?.[1]?.title,
          currentData?.[2]?.title,
        ],
        videoSeoTitle: [
          currentData?.[0].seoTitle,
          currentData?.[1].seoTitle,
          currentData?.[2].seoTitle,
        ],

        thumbnailImage: [
          currentData?.[0].thumbnailImage,
          currentData?.[1].thumbnailImage,
          currentData?.[2].thumbnailImage,
        ],

        alt: currentData?.[0].title,
        btnText: latest?.[0].title,
        videoDescription: [
          currentData?.[0].about,
          currentData?.[1].about,
          currentData?.[2].about,
        ],
      };
    }
    return null;
  }, [latest]);

  return (
    <section className={styles["hm-category-rows"]}>
      <header className={styles["title"]}>
        <h1>Latest Courses</h1>
      </header>
      <article
        className={`${styles["hm-category-videos"]} ${!latest.length ? styles["loading"] : ""}`}
      >
        <button
          className={`${styles["slider-nav-button"]} ${styles["prev"]}`}
          id="CP_Latest_Course_Left_Btn"
        >
          <Icon icon={"mdi:keyboard-arrow-left"} />
        </button>
        {latest && latest.length > 0 ? (
          <Swiper
            slidesPerView={vidPerView}
            spaceBetween={gap}
            freeMode={true}
            pagination={false}
            modules={[FreeMode, Navigation]}
            navigation={{
              prevEl: "#CP_Latest_Course_Left_Btn",
              nextEl: "#CP_Latest_Course_Right_Btn",
            }}
            className={styles["latestvideo-swiper"]}
          >
            {latest.map((course, i) => (
              <SwiperSlide key={i}>
                <Components.CourseCard
                  type="course"
                  id={course?._id}
                  seoTitle={course?.seoTitle}
                  videoTitle={course?.firstVideoTitle}
                  visibility={course?.visibility}
                  image={course?.thumbnailImage}
                  tag={course?.categories}
                  enrollCount={course?.enrolled_count}
                  title={course?.title}
                  videoCount={course?.videosCount}
                  timeCount={course?.totalTime}
                  creatorInfo={{
                    id: course?.creatorInfo?.[0]?._id,
                    name: course?.creatorInfo?.[0]?.name,
                    username: course?.creatorInfo?.[0]?.username,
                    image: course?.creatorInfo?.[0]?.profileImage,
                  }}
                  currentCourse={i === 0 ? "1" : null}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <sk.RowCardSkeleton number={Math.ceil(vidPerView)} />
        )}
        <button
          className={`${styles["slider-nav-button"]} ${styles["next"]}`}
          id="CP_Latest_Course_Right_Btn"
        >
          <Icon icon="mdi:keyboard-arrow-right" />
        </button>
      </article>
      {unwrap ? <Components.UnWrap {...unwrap} /> : null}
    </section>
  );
}

export default Components.CardWrapper(LatestCourse);
